const getRelativeParent = (element) => {
    if (!element) {
        return null;
    }

    const position = window.getComputedStyle(element).getPropertyValue('position');
    if (position !== 'static') {
        return element;
    }

    return getRelativeParent(element.parentElement);
};

const positionSuggestions = ({ decoratorRect, popover, state, props }) => {
    const relativeParent = getRelativeParent(popover.parentElement);
    const relativeRect = {};

    if (relativeParent) {
        relativeRect.scrollLeft = relativeParent.scrollLeft;
        relativeRect.scrollTop = relativeParent.scrollTop;

        const relativeParentRect = relativeParent.getBoundingClientRect();
        relativeRect.left = decoratorRect.left - relativeParentRect.left;
        relativeRect.top = decoratorRect.bottom - relativeParentRect.top;
    } else {
        relativeRect.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        relativeRect.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        relativeRect.top = decoratorRect.bottom;
        relativeRect.left = decoratorRect.left;
    }

    const left = relativeRect.left + relativeRect.scrollLeft;
    const top = relativeRect.top + relativeRect.scrollTop;

    let transform;
    if (state.isActive) {
        if (props.suggestions.length > 0 || props.disabledSuggestions.length) {
            transform = 'scale(1)';
        } else {
            transform = 'scale(0)';
        }
    }

    return {
        left: `${left}px`,
        top: `${top}px`,
        transform,
        transformOrigin: '1em 0%',
    };
};

export default positionSuggestions;
